(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const productSection = root.closest('.main-product') || root.closest('[id^="MainProduct-"]') || root.parentElement;
    const variantData = root.querySelector('[data-birdega-waitlist-variants]');
    const tagInput = root.querySelector('[data-waitlist-tags]');
    const emailInput = root.querySelector('input[type="email"]');
    const clientError = root.querySelector('[data-waitlist-client-error]');
    const waitlistStatus = root.querySelector('[data-waitlist-status]');
    const productHandle = root.dataset.productHandle;
    let variants = [];

    try {
      variants = JSON.parse(variantData?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const getVariantId = () => {
      const mainInput = productSection?.querySelector('product-form form input[name="id"]');
      const fallbackInput = productSection?.querySelector('form[action*="/cart/add"] input[name="id"]');
      return String(mainInput?.value || fallbackInput?.value || '');
    };

    const update = () => {
      const variantId = getVariantId();
      const variant = variants.find((item) => String(item.id) === variantId);
      const submit = productSection?.querySelector('[id^="ProductSubmitButton-"]');
      const soldOut = variant ? !variant.available : Boolean(submit?.disabled || submit?.hasAttribute('data-sold-out'));
      const productInfo = root.closest('.product__info-container') || productSection;

      root.classList.toggle('birdega-product-waitlist--hidden', !soldOut);
      root.setAttribute('aria-hidden', soldOut ? 'false' : 'true');
      productInfo?.classList.toggle('birdega-variant-sold-out', soldOut);

      if (waitlistStatus) {
        const nativeSoldOutBadge = productSection?.querySelector('.card__badges-item--sold');
        waitlistStatus.hidden = !soldOut || Boolean(nativeSoldOutBadge);
      }

      if (tagInput && variantId) {
        tagInput.value = `newsletter,first-access,waitlist,waitlist-${productHandle},variant-${variantId}`;
      }
    };

    const scheduleUpdate = () => {
      window.setTimeout(update, 0);
      window.setTimeout(update, 120);
      window.setTimeout(update, 300);
    };

    productSection?.addEventListener('change', scheduleUpdate);
    document.addEventListener('variant:change', scheduleUpdate);
    document.addEventListener('product:variant-change', scheduleUpdate);

    const submit = productSection?.querySelector('[id^="ProductSubmitButton-"]');
    if (submit) {
      new MutationObserver(update).observe(submit, {
        attributes: true,
        attributeFilter: ['disabled', 'data-sold-out', 'aria-disabled']
      });
    }

    if (emailInput && clientError) {
      emailInput.addEventListener('invalid', (event) => {
        event.preventDefault();
        clientError.hidden = false;
        emailInput.setAttribute('aria-describedby', clientError.id);
        emailInput.setAttribute('aria-invalid', 'true');
      });

      emailInput.addEventListener('input', () => {
        if (emailInput.validity.valid) {
          clientError.hidden = true;
          emailInput.removeAttribute('aria-invalid');
          emailInput.removeAttribute('aria-describedby');
        }
      });
    }

    update();
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-birdega-waitlist]').forEach(init);

  window.BirdegaWaitlistBoot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('quickview:loaded', () => boot(document));
})();
